import React, {useContext, useEffect, useState}from "react";
import { useHistory, useParams } from "react-router-dom";
import Button from "../../shared/components/formElements/Button";
import Avatar from "../../shared/components/UIElements/Avatar";
import Card from "../../shared/components/UIElements/Card";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import FloatingButton from "../../shared/components/UIElements/FloatingButton";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import Modal from "../../shared/components/UIElements/Modal";
import logo from "../../assets/logo/webscript.png";
import { useHttpClient } from "../../shared/hooks/http-hook";
import { AuthContext } from '../../shared/context/auth-context';

import "./SendBackInfo.css";

const SendBacksInfo = () => {
    const auth = useContext(AuthContext);
  const history = useHistory();
  const [loadedSendBack, setLoadedSendBack] = useState();
  const [showConfirmModal, setShowConfirmModal] = useState("");
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [isPrint, setIsPrint] = useState(true);
  const sendBacksID= useParams().sendbacksId;

  useEffect(() =>{
    const fetchSendBacks = async () =>{
        try {
            const responseData = await sendRequest(
                process.env.REACT_APP_BACKEND_URL+`/sendBacks/${sendBacksID}`,
                "GET",
                null,
                {Authorization: 'Bearer '+ auth.token}
            );
            setLoadedSendBack(responseData.sendBack);
        } catch (err) {}
    };
    fetchSendBacks();
  },[sendRequest, sendBacksID, auth.token]);


const showWarningHandler = (task) =>{
    setShowConfirmModal(task);
  }

  const cancelWarningHandler =() =>{
    setShowConfirmModal("");
  }
  const confirmDeleteHandler = async () =>{
    setShowConfirmModal("");
    try {
        await sendRequest(process.env.REACT_APP_BACKEND_URL+`/sendBacks/${sendBacksID}`,
         "DELETE",
         null,
         {Authorization: 'Bearer '+ auth.token}
        );
        history.push("/sendBacks");
    } catch (err) { }
  }
  
  
  const confirmReturnHandler = async () => {
    setShowConfirmModal("");
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL+"/consignments/new",
        "POST",
        JSON.stringify({
          style: loadedSendBack.style,
          company: loadedSendBack.company,
          color: loadedSendBack.color,
          USSize: loadedSendBack.USSize,
          EURSize: loadedSendBack.EURSize,
          quantity: loadedSendBack.quantity,
          cost: loadedSendBack.cost,
          price: loadedSendBack.price,
          website: loadedSendBack.website,
          description: loadedSendBack.description,
          issueDate: new Date()
        }),
        { "Content-Type": "application/json" ,
        Authorization: 'Bearer '+ auth.token}
      );
      
    } 
    catch (err) { return; }
    try {
      await sendRequest(process.env.REACT_APP_BACKEND_URL+`/sendBacks/${sendBacksID}`,
      "DELETE",
      null,
      {Authorization: 'Bearer '+ auth.token}
      );
      history.push("/consignments");
    } catch (err) { return; }
  }
  
  return (
    <React.Fragment>
        <ErrorModal error={error} onClear={clearError} />
        {isLoading && (<div className="center"><LoadingSpinner /></div>)}
        <Modal
        show={showConfirmModal}
        onCancel={cancelWarningHandler}
        header="Are you sure?"
        footerClass="items-item__modal-actions"
        footer={
          <React.Fragment>
            <Button inverse onClick={cancelWarningHandler}>
              CANCEL
            </Button>
            {
               showConfirmModal === "DELETE" 
              //  &&
                ?
                <Button danger onClick={confirmDeleteHandler}>
                  DELETE
                </Button>
                 :
                <Button secondary onClick={confirmReturnHandler}>
                  SEND BACK
                </Button> 
            }
          </React.Fragment>
        }
      >       
      <p>
          {`Do you want to proceed and ${showConfirmModal.toLowerCase()} 
          this item`} <b>{`${showConfirmModal === "SEND BACK" ? "to consignment" :""}`}</b>{`?`}
      {`${showConfirmModal === "DELETE" ?  " Please note that it can't be undone thereafter." : ""}`}
      
      </p>
      </Modal> 
      {!isLoading && loadedSendBack && (
        <li className="sendBacks-list">
          <Card className="sendBacks-item__content">
            <div className="container">
              <div className="row">
                <div className="col">
                  <form className="send-back-form">
                    <div className="print-button">
                      {isPrint ? 
                    <Button inverse onClick={(e) => {e.preventDefault(); setIsPrint(!isPrint);}}>                
                      PRINT
                    </Button> :
                    <Button inverse onClick={(e) => {e.preventDefault(); setIsPrint(!isPrint); window.print();setIsPrint(!isPrint);}}>                
                      🖨️
                    </Button>}
                    </div>
                    <br />
                    {isPrint && <h2 className="header-text">Send Back Details</h2>}

                    <div className="flex justify-center">
                      <div className=" w-50 mr1">
                        <label>Style</label>
                        <input readOnly type="text" value={loadedSendBack.style.split('_')[0]} />
                      </div>
                      <div className=" w-50  mr1">
                        <label>Company</label>
                        <input
                          readOnly
                          type="text"
                          value={loadedSendBack.company}
                        />
                      </div>
                    </div>
                    <div className="flex justify-center">
                      <div className=" w-50  mr1">
                        <label>Color</label>
                        <input readOnly type="text" value={loadedSendBack.color? loadedSendBack.color : "N/A"} />
                      </div>
                      <div className=" w-50  mr1">
                        <label>US Size</label>
                        <input readOnly type="text" value={loadedSendBack.USSize ? loadedSendBack.USSize : 1} />
                      </div>
                      <div className=" w-50  mr1">
                        <label>EUR Size</label>
                        <input
                          readOnly
                          type="text"
                          value={loadedSendBack.EURSize ? loadedSendBack.EURSize : 1}
                        />
                      </div>
                    </div>

                    <div className="flex justify-center">
                      <div className=" w-50  mr1">
                        <label>Quantity</label>
                        <input
                          readOnly
                          type="text"
                          value={loadedSendBack.quantity }
                        />
                      </div>
                      {isPrint && <div className=" w-50  mr1">
                      <label>Cost</label>
                      <input readOnly type="text" value={loadedSendBack.cost ? "$"+loadedSendBack.cost : "N/A"} />
                    </div>}

                      <div className=" w-50 mr1">
                        <label>Price</label>
                        <input readOnly type="text" value={loadedSendBack.price ? "$"+loadedSendBack.price : "N/A" } />
                      </div>
                    </div>
                    <div className="flex justify-left">
                      {  isPrint && <div className=" w-50 mr1">
                            <label>Website</label>
                            <input  readOnly type="text" value={loadedSendBack.website ? loadedSendBack.website : "N/A"}/>
                        </div>}
                        <div className=" w-50 mr1">
                            <label>Description</label>
                            <textarea readOnly value={loadedSendBack.description} />
                        </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="image-container">
              <div className="sendBacks-avatar">
                {loadedSendBack.website ? (
                  <img
                    src={loadedSendBack.website}
                    alt=""
                    width="auto"
                    height="auto"
                  />
                ) : (
                  <Avatar image={logo} />
                )}
              </div>
            </div>

            {isPrint && <div className="sendBacks-item__actions">
              <Button inverse to="/sendBacks">
                BACK
              </Button>
              <Button to={`/sendBacks/${sendBacksID}/edit`}>
                EDIT
              </Button>
              <Button danger onClick={() => showWarningHandler("DELETE")}>
                DELETE
              </Button>
              <Button secondary onClick={() => showWarningHandler("SEND BACK")}>
                SEND BACK
              </Button>
            </div>}
          </Card>
        </li>
      )}
      {isPrint && <FloatingButton icon={"back"} />}
    </React.Fragment>
  );
};

export default SendBacksInfo;